import type { FunctionComponent } from "react";

import { BaseLink } from "scmp-app/components/common/base-link";
import { ClientSideSuspense } from "scmp-app/components/common/client-side-suspense";
import { tracking } from "scmp-app/data";
import { useEditionValue } from "scmp-app/lib/edition";
import { useCurrentPageType, useGetHomeAsPath } from "scmp-app/lib/router/hooks";
import { page as HomePage } from "scmp-app/pages/home";
import { page as PostiesPage } from "scmp-app/pages/posties";

import {
  Container,
  Content,
  Copyright,
  Header,
  LogoCopyrightContainer,
  LogoPosties,
  StyledLogoScmp,
  StyledPostiesEnquires,
  StyledPostiesSitemap,
  StyledPostiesSocialMedia,
  Wrapper,
} from "./styles";

export const PostiesFooter: FunctionComponent = () => {
  const edition = useEditionValue();
  const homeAsPath = useGetHomeAsPath();

  const { pathname: postiesPagePathname, query: postiesPageQuery } = PostiesPage.route({});
  const { pathname: homePagePathname, query: homePageQuery } = HomePage.route({
    edition,
    slide: "main",
  });

  const currentPageType = useCurrentPageType();
  const postiesFooterQueryParameters = {
    module: tracking.module.FooterPosties,
    pgtype: currentPageType,
  };

  return (
    <Container>
      <Wrapper>
        <Header>
          <BaseLink
            as="/posties"
            pathname={postiesPagePathname}
            query={{ ...postiesPageQuery, ...postiesFooterQueryParameters }}
          >
            <LogoPosties />
          </BaseLink>
          <StyledPostiesSocialMedia />
        </Header>
        <Content>
          <ClientSideSuspense>
            <StyledPostiesSitemap postiesFooterQueryParameters={postiesFooterQueryParameters} />
            <StyledPostiesEnquires />
          </ClientSideSuspense>
        </Content>
        <LogoCopyrightContainer>
          <BaseLink
            as={homeAsPath}
            pathname={homePagePathname}
            query={{ ...homePageQuery, ...postiesFooterQueryParameters }}
          >
            <StyledLogoScmp />
          </BaseLink>
          <Copyright>
            Copyright © {new Date().getFullYear()} South China Morning Post Publishers Ltd. All
            rights reserved.
          </Copyright>
        </LogoCopyrightContainer>
      </Wrapper>
    </Container>
  );
};

PostiesFooter.displayName = "PostiesFooter";
